<template>
    <div class="acountStatus"> 
        <div class="mainTitle text-center my-3">
            <h3 class="mb-4">{{$t('openTrades')}}</h3> 
        </div>
        <div class="mapIco-list-table mt-4">
            <app-open-trades :pageName="'open-trade'"></app-open-trades>
        </div>
    </div>   
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    import openTrades from '../shared/tradingAccounts/open_trades_listing'
    export default {
        name: 'Open-Trade',
        mixins: [fxViewMixins],
        data() {
            return {
            }
        },
        components: {
            appOpenTrades: openTrades
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/tradingAccounts/open_trades_listing.vue